import { render } from "./RoomDetail.vue?vue&type=template&id=5cf35d1a"
import script from "./RoomDetail.vue?vue&type=script&lang=js"
export * from "./RoomDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__